import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import OldSignatoriesPage from './OldSignatoriesPage';
import { redirectToPage } from '../../store/dataCapture';

import {
  OLD_SIGNATORIES_KEYS,
  ROUTE_OLD_ACCOUNT_DETAILS_PAGE,
  ROUTE_OLD_ADD_SIGNATORY_PAGE
} from '../../utils/constants';
import {
  oldSignatoriesSelector,
  updateOldSignatories,
  removeOldSignatories,
  saveOldAddSignatoryForm
} from '../../infrastructure/oldSignatories';

class OldSignatoriesSection extends Component {
  constructor(props) {
    super(props);
    this.businessBack = this.businessBack.bind(this);
  }

  businessBack() {
    this.props.history.push(ROUTE_OLD_ACCOUNT_DETAILS_PAGE);
  }

  render() {
    const {
      bankId,
      brandId,
      oldSignatories,
      offer,
      redirectToPage,
      updateOldSignatories,
      removeOldSignatories,
      saveOldAddSignatoryForm
    } = this.props;

    return (
      <OldSignatoriesPage
        brandId={brandId}
        bankId={bankId}
        offer={offer}
        redirectToPersonalInfo={() => {
          redirectToPage(ROUTE_OLD_ADD_SIGNATORY_PAGE);
        }}
        saveOldSignatoriesForm={saveOldAddSignatoryForm}
        oldSignatories={oldSignatories}
        backClick={this.businessBack}
        updateOldSignatories={updateOldSignatories}
        removeOldSignatories={removeOldSignatories}
      />
    );
  }
}

OldSignatoriesSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveOldAddSignatoryForm: PropTypes.func.isRequired
};

const actionCreators = {
  redirectToPage,
  updateOldSignatories,
  removeOldSignatories,
  saveOldAddSignatoryForm
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  oldSignatories: oldSignatoriesSelector.getBusinessData(state, OLD_SIGNATORIES_KEYS)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OldSignatoriesSection);
